import Form, { formCreate } from '@/found/components/form';
import request from '@/found/utils/request';
import detailsInfo from './details.vue';

formCreate.component('detailsInfo', detailsInfo);
export default {
  extends: Form,
  data() {
    return {
      formFunctionCode: 'terminal_form',
      formParentCode: 'CRM20240418000000002',
    };
  },
  components: {
    formCreate: formCreate.$form(),
  },
  created() {

  },

  methods: {
    formComplete() {
      this.getDetails();
      console.log(this.formConfig);
    },
    setRule(item) {
      const v = item;
      return v;
    },
    async getDetails() {
      await request.post('/cps/agreeShare/activitiFormQuery', { id: this.formConfig.row.id || this.id }).then((res) => {
        if (res.success) {
          let resuletObj = {};
          const pileSampleUrlArry = [];
          const shelfSampleUrlArry = [];
          resuletObj = res.result.templateVo.displayRespVo;
          res.result.templateVo.displayRespVo.shelfSampleUrl.forEach((element) => {
            shelfSampleUrlArry.push(element.url);
          });
          res.result.templateVo.displayRespVo.pileSampleUrl.forEach((element) => {
            pileSampleUrlArry.push(element.url);
          });
          this.setValue({
            ...res.result,
          });
          const detailsInfoData = this.getRule('detailsInfo');
          detailsInfoData.props = {
            ...detailsInfoData.props,
            obj: resuletObj,
            products: res.result.templateVo.products,
            groupProducts: res.result.templateVo.groupProducts,
            shelfSampleUrlArry,
            pileSampleUrlArry,
          };
        }
      });
    },
  },
};
